// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rating-progress-wrapper[data-v-4c572730]{align-items:center;display:flex;justify-content:space-between}.rating-progress[data-v-4c572730]{background:#e9f0fa;flex-basis:90%;height:10px}.progress-bar[data-v-4c572730]{background:#28a745}.progress-score[data-v-4c572730]{font-size:12px;font-weight:500}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
